module.exports = __webpack_public_path__ + "static/media/Lesson-8-27-God-is-Always-Willing-and-Able.6212d3b4.pdf";